module.exports = __webpack_public_path__ + "img/bg-poster.eaea162e.jpg";